<template>
  <div class="admin-settings">
    <header-title :title="title"></header-title>

    <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>
    <br />
    <v-container fluid class="pl-0 pr-0">
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" sm="3" class="py-0 py-sm-1">
            <v-subheader :style="{ color: formLabelTheme }" class="px-0 px-sm-1"
              >Crear tipo de productos y horarios por defecto :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="3" class="py-0 py-sm-1 d-flex">
            <v-switch
              class="mt-2"
              v-model="input.initializedProject"
              @change="onInitProject"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="3" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Recalcular Cierres de Caja :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="3" class="py-0 py-sm-1 d-flex">
            <v-btn
              dense
              outlined
              color="primary"
              href="/try-out/update-zclousure"
              target="_blank"
            >
              Recalcular
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="3" class="py-0 py-sm-1">
            <v-subheader
              :style="{ color: formLabelTheme }"
              class="px-0 px-sm-1"
            >
              Recalcular Números de Pago :
            </v-subheader>
          </v-col>
          <v-col cols="12" sm="3" class="py-0 py-sm-1 d-flex">
            <v-btn
              dense
              outlined
              color="primary"
              href="/try-out/update-payment-number"
              target="_blank"
            >
              Recalcular
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import Loader from "@/components/common/Loader";
import firebaseMixin from "../../../mixins/firebase/firebaseMixin";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { getSettingById, updateSetting } from "@/collections/settings";

export default {
  name: "Settings-Maintenance",
  components: { Loader, HeaderTitle },
  mixins: [firebaseMixin],
  data() {
    return {
      dialogLoader: false,
      title: "Mantenimiento",
      input: {
        initializedProject: false
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async onInitProject(value) {
      this.initProject();

      await updateSetting("settings", {
        initializedProject: value
      });
    },
    async getData() {
      let self = this;
      this.dialogLoader = true;

      let setting;
      try {
        setting = await getSettingById("settings");

        self.dialogLoader = false;
        self.input = setting;

        if (self.input.initializedProject === undefined) {
          self.input = {
            ...self.input,
            initializedProject: false
          };
        }
      } catch (error) {
        this.setlogError(
          "get_setting",
          "Error obteniendo settings",
          error.stack,
          this.$options.name
        );
        self.dialogLoader = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.icons-img {
  width: 100px;
  height: 100px;
  align-items: center;
  display: flex;
  padding: 10px;
  border: 2px solid darkgray;
  justify-content: center;
  min-width: 100px;
}
.icons-img img {
  max-width: 100%;
  max-height: 80px;
}
</style>
